import { render } from "./AssTeacherHome.vue?vue&type=template&id=d69f6ebc&scoped=true"
import script from "./AssTeacherHome.vue?vue&type=script&lang=js"
export * from "./AssTeacherHome.vue?vue&type=script&lang=js"

import "./AssTeacherHome.vue?vue&type=style&index=0&id=d69f6ebc&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d69f6ebc"]])

export default __exports__